import { render, staticRenderFns } from "./InternetTest.vue?vue&type=template&id=42389301&scoped=true&"
import script from "./InternetTest.vue?vue&type=script&lang=js&"
export * from "./InternetTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42389301",
  null
  
)

export default component.exports